<template>
  <aside :class="`app-layout-sider ${collapse ? 'collapseActive' : ''}`">
    <div class="app-layout-sider-inner">
      <div
        class="app-layout-sider-inner-collapse"
        @click="setCollapse(!collapse)"
      >
        <i :class="`${collapse ? 'el-icon-arrow-right' : 'el-icon-arrow-left'}`" />
      </div>
      <section class="menu">
        <el-scrollbar wrap-class="scrollbar-wrapper">
          <el-menu
            :default-active="activeMenu"
            :unique-opened="true"
            :collapse-transition="false"
            :background-color="variables.menuBg"
            :text-color="variables.menuText"
            :active-text-color="variables.menuTextActive"
            mode="vertical"
            :collapse="collapse"
          >
            <sidebar-item
              v-for="menu in menuList"
              :key="menu.name"
              :item="menu"
            />
          </el-menu>
        </el-scrollbar>
      </section>
    </div>
  </aside>
</template>

<script>
import {
  mapGetters, mapActions,
} from 'vuex';
import variables from '@/styles/theme/default.scss';
import { contantRoutes } from '@/router';
import SidebarItem from './sidebar-item.vue';

export default {
  name: 'AppSider',
  data: () => ({
    menuList: contantRoutes,
  }),
  created() {
  },
  components: {
    SidebarItem,
  },
  computed: {
    ...mapGetters(
      'menu',
      [
        'collapse',
      ],
    ),
    variables() {
      return variables;
    },
    activeMenu() {
      const route = this.$route;
      const { name } = route;

      return name;
    },
  },
  methods: {
    ...mapActions(
      'menu',
      ['setCollapse'],
    ),
  },
};
</script>

<style lang="scss">
.menu-wrapper {
  text-align: left;
}
.app-layout {
  &-sider {
    position: relative;
    width: $app-sider-width;
    transition: all 0.2s;
    z-index: 201;
    color: #fff;
    position: fixed;
    top: 60px;
    left: 0;
    min-height: calc(100vh);
    &.collapseActive {
      width: $app-sider-width-min;
    }

    &-mask {
      position: fixed;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.65);
      transition: opacity 0.3s linear;
      z-index: 201;
    }

    &-inner {
      background: $app-sider-menu-fill;
      position: relative;
      z-index: 203;
      box-shadow: 1px 0px 4px 0px rgba(0, 21, 41, 0.05);

      &-collapse {
        position: absolute;
        right: 0;
        top: 50%;
        z-index: 202;
        color: #9a9a9a;
        background: #fff;
        right: -14px;
        box-shadow: 2px 0px 4px 0px rgba(0, 21, 41, 0.05);
        border-radius: 0 3px 3px 0;
        cursor: pointer;
      }
    }

    &.hide {
      width: $app-sider-width-min;
    }

    .logo {
      position: relative;
      height: $app-header-height;
      line-height: $app-header-height;
      overflow: hidden;
      background: $app-sider-logo-fill;
      transition: all 0.3s;
      text-align: center;

      img {
        display: inline-block;
        height: $app-header-height / 2.5;
        vertical-align: middle;
      }

      h1 {
        display: inline-block;
        margin: 0 0 0 12px;
        color: #fff;
        font-weight: 500;
        font-size: 18px;
        vertical-align: middle;
      }
    }

    .menu {
      padding: 16px 0;
      height: calc(100vh);
      overflow: hidden;
    }
  }
}
</style>

<style lang="scss">
// @TODO: min stauts menu atived

.app-layout-sider {
  .el-scrollbar {
    height: 100%;
  }

  .scrollbar-wrapper {
    position: relative;
    overflow-x: hidden !important;
  }

  .el-menu-item,
  .el-submenu__title {
    height: 40px;
    line-height: 40px;
    margin-top: 4px;
    margin-bottom: 4px;

    &.is-active {
      color: $menu-text-active !important;
      background-color: $menu-bg-active !important;
      border-right: 4px solid $menu-text-active;
    }
  }

  // .el-submenu.is-active .el-submenu__title:first-child {
  //   color: $menu-text-active !important;
  //   border-bottom-color: transparent;
  // }

  .el-menu {
    border-right: none;
    .el-menu-item,
    .el-submenu__title {
      &:not(.is-active) {
        &:hover {
          background: $menu-hover-bg-active !important;
        }
      }

      .icon-svg {
        font-size: 16px;
        margin-right: 6px;
        vertical-align: middle;
      }
    }
  }

  .el-submenu .el-menu {
    background-color: $sub-menu-bg !important;

    .el-menu-item,
    .el-submenu__title {
      background-color: $sub-menu-bg !important;

      &.is-active {
        background-color: $menu-bg-active !important;
      }
    }

    .el-menu {
      background-color: $sub-menu-bg !important;
    }
  }

  // min status
  .el-menu--collapse {
    width: $app-sider-width-min;

    .el-menu-item.is-active,
    .el-submenu__title.is-active {
      background-color: transparent !important;
    }

    .el-menu-item,
    .el-submenu__title {
      text-align: center;
    }

    .el-menu-item .icon-svg,
    .el-submenu__title .icon-svg {
      margin-right: 0;
    }

    .el-submenu > .el-submenu__title > span {
      height: 0;
      width: 0;
      overflow: hidden;
      visibility: hidden;
      display: inline-block;
    }

    .el-submenu > .el-submenu__title .el-submenu__icon-arrow {
      display: none;
    }
  }
}
</style>
